import WaitingRoomContentContainer from './WaitingRoomContentContainer';

export default WaitingRoomContentContainer;
